import { SentryErrorBoundary } from '@betterment/shared-components';
import { StyleClosetThemeProvider, ThemeName } from '@betterment/style-closet-react';
import { Controller } from '@hotwired/stimulus';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import appShell from '../../AppShell';

interface Root {
  render(children: React.ReactNode): void;
  unmount(): void;
}
export default class extends Controller {
  root: Root | undefined;

  connect() {
    const componentName = this.data.get('name')!;
    const Component = Sentry.withProfiler(appShell.getComponent(componentName), { name: componentName });
    if (Component) {
      this.root = createRoot(this.element);
      this.root.render(
        <SentryErrorBoundary>
          <StyleClosetThemeProvider theme={this.theme}>
            <Component {...this.initialProps} />
          </StyleClosetThemeProvider>
        </SentryErrorBoundary>
      );
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Could not resolve React component with name: '${componentName}'`);
    }
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }

  get initialProps() {
    return JSON.parse(this.data.get('initial-props') || '{}') as Record<string, unknown>;
  }

  get theme() {
    return (document.querySelector<HTMLMetaElement>('meta[name="theme"]')?.content || 'default') as ThemeName;
  }
}
